import { useContext, useEffect } from 'react';
import { Loading, MentorForm } from '../../components';
import { useProtectComponent } from '../../hooks/useProtectComponent';
import { ProfileContext } from '../../contexts';
import { useNavigate } from 'react-router-dom';
import { registerView } from '../../helpers';

export const Mentor = () => useProtectComponent(Mentor_);
const Mentor_ = () => {
  const { profile } = useContext(ProfileContext);
  const navigate = useNavigate();

  useEffect(() => {
    const isDeadlineOver = profile?.deadline?.isDeadlineOver;
    // TODO: Uncomment this section
    if (typeof isDeadlineOver !== 'boolean') return;
    if (isDeadlineOver) {
      registerView(profile, 'Deadline is over - cannot access this route');
      navigate('/');
      return;
    }
    registerView(profile);
  }, [profile?.deadline?.isDeadlineOver]);

  if (!profile) {
    return (
      <div className="App-content App-loading-content">
        <Loading />
      </div>
    );
  }

  if (!profile?.email) {
    return (
      <div className="App-content">
        <div className="App-row" style={{ margin: '0 auto' }}>
          <h2
            style={{
              textAlign: 'center',
              margin: '2rem auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            You have to be a NAR member to be a mentor. &nbsp;
            <a href="/">Go home</a>
          </h2>
        </div>
        <div className="App-row">
          <p>
            <br />
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="App-content">
      <div className="App-row">
        <MentorForm userData={profile} />
      </div>
      <div className="App-row">
        <p>
          <br />
        </p>
      </div>
    </div>
  );
};
